import { useParams } from 'react-router-dom';
import { GenerateTestDataButton } from './GenerateTestDataButton';
import { generateTestSubscriptions } from '../utils/subscriptionsGenerator';

export const GenerateSubscriptionsButton = () => {
  const { id: customerId } = useParams();
  const generateFunction = (count: number) => generateTestSubscriptions(count, customerId);

  return (
    <GenerateTestDataButton 
      label="Generate Subscriptions" 
      generateFunction={generateFunction} 
      queryKey={['subscriptions']} 
    />
  );
};